const KEY = "embethat:guestId";

export function getGuestId(): string {
  let id = localStorage.getItem(KEY);
  if (!id || !/^[0-9a-f-]{36}$/i.test(id)) {
    id = crypto.randomUUID();
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function clearGuestId() {
  localStorage.removeItem(KEY);
}
